interface CompanyCardProps {
  company: {
    id: string;
    name: string;
    logo?: string;
  };
  isSelected: boolean;
  onSelect: React.Dispatch<React.SetStateAction<string | null>>;
}

export default function CompanyCard({
  company,
  isSelected,
  onSelect,
}: CompanyCardProps) {
  return (
    <button
      onClick={() =>
        onSelect(prev => (prev === company.id ? null : company.id))
      }
      className={`p-3 m-2 rounded-lg bg-themeGrey transition-all duration-200 text-left cursor-pointer flex items-center gap-3 ${
        isSelected ? "ring-4 ring-themeCore" : "hover:bg-white"
      }`}
    >
      <div
        className={`w-12 h-12 rounded-lg flex items-center justify-center text-lg font-semibold flex-shrink-0 transition-colors ${
          isSelected ? "bg-blue-100 text-blue-700" : "bg-gray-100 text-gray-500"
        }`}
      >
        <img className="w-12 h-12 object-contain" src={company?.logo} alt="" />
      </div>

      <p
        style={{ fontSize: "16px" }}
        className={`font-medium  truncate flex-1 ${
          isSelected ? "text-foreground" : "text-foreground"
        }`}
      >
        {company.name}
      </p>

      {/* {isSelected && (
        <div className="w-5 h-5 rounded-full bg-primary flex items-center justify-center flex-shrink-0">
          <svg
            className="w-3 h-3 text-primary-foreground"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      )} */}
    </button>
  );
}
